import { createContext, useContext, useEffect } from 'react';
import { useDataActions } from '../../../hooks/useDataActions';
import { useRowModel } from '../../../hooks/useRowModel';
export const useRegvarImport = (regvar)=>{
    const importCtx = useContext(RegvarImportContext);
    const row = useRowModel();
    const dataActions = useDataActions();
    let importableValues, isImported, onImport = null;
    useEffect(()=>{
        if (importCtx) {
            importCtx.syncImport(dataActions, regvar);
        }
    }, [
        importCtx,
        dataActions,
        regvar
    ]);
    if (!importCtx) {
        // Ingen importfunktion finns tillgänglig, gör inget
        return null;
    } else {
        // Importkontextet har använts och möjlighet finns för variabelimport
        // Alla värden som kan importeras för en given variabel och rad
        importableValues = importCtx.getImportableValues(row, regvar);
        // Om variabeln är importerad från källa
        isImported = importCtx.isImported(regvar);
        // Funktion som importerar värde till variabeln
        onImport = (value)=>importCtx.onImport(dataActions, regvar, value);
    }
    return {
        importableValues,
        isImported,
        onImport
    };
};
export const RegvarImportContext = createContext(null);
